import type { RecursiveRequired, Settings } from '#/global'
import { cloneDeep } from 'es-toolkit'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'

const globalSettings: Settings.all = {
  app: {
    lightTheme: 'blue',
    darkTheme: 'blue',
    routeBaseOn: 'filesystem',
    enablePermission: true,
  },
  menu: {
    mode: 'only-head',
  },
  toolbar: {
    enable: false,
    breadcrumb: false,
    navSearch: false,
  },
  mainPage: {
    enableHotkeys: false,
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
